// FK_StatusElements_SpriteSheet_01.png — 192×48px, 16×16 frames, displayed at 2x (32×32)
//   Row 0: col0=rat icon, col1=×, col2-10=digits 1-9, col11=digit 0
//   Row 1: col0=coin, col1=...
//   Row 2: col0=heart full, col1=heart half, col2=heart empty

const STATUS_SHEET = 'assets/tilesets/FK_StatusElements_SpriteSheet_01.png';

function statusFrame(col, row) {
    return `background-image:url('${STATUS_SHEET}');background-size:384px 96px;background-position:${-col*32}px ${-row*32}px;`;
}

// Digit 0 is at col 11; digits 1-9 are at cols 2-10
function digitFrame(d) {
    return statusFrame(d === 0 ? 11 : d + 1, 0);
}

// state: 'full' | 'half' | 'empty'
function heartStyle(state) {
    const col = state === 'full' ? 0 : state === 'half' ? 1 : 2;
    return statusFrame(col, 2);
}

const SPRITE = `display:inline-block;width:32px;height:32px;image-rendering:pixelated;image-rendering:crisp-edges;`;

export default class StatusPanel {
    constructor(scene, player, lives = 4) {
        this.scene = scene;
        this.player = player;
        this.coinCount = 0;
        this.lives = lives;
        this.heartEls = [];
        this.coinDigitEls = [];
        this.livesDigitEl = null;
        this.create();
    }

    create() {
        const bar = document.createElement('div');
        bar.id = 'status-panel';
        bar.style.cssText = `
            position: fixed;
            bottom: 0;
            left: 0;
            right: 0;
            height: 56px;
            background: #111;
            display: flex;
            align-items: center;
            padding: 0 32px;
            gap: 40px;
            z-index: 1000;
            box-sizing: border-box;
        `;

        // — Hearts —
        const heartsGroup = document.createElement('div');
        heartsGroup.style.cssText = 'display:flex;gap:2px;align-items:center;';
        for (let i = 0; i < 4; i++) {
            const h = document.createElement('div');
            h.style.cssText = SPRITE + heartStyle('full');
            this.heartEls.push(h);
            heartsGroup.appendChild(h);
        }
        bar.appendChild(heartsGroup);

        // — Coin × 0 —
        const coinGroup = document.createElement('div');
        coinGroup.style.cssText = 'display:flex;gap:4px;align-items:center;';

        const coinIcon = document.createElement('div');
        coinIcon.style.cssText = SPRITE + statusFrame(0, 1);
        coinGroup.appendChild(coinIcon);

        const timesCoins = document.createElement('div');
        timesCoins.style.cssText = SPRITE + statusFrame(1, 0);
        coinGroup.appendChild(timesCoins);

        this.coinDigitContainer = coinGroup;

        const d = document.createElement('div');
        d.style.cssText = SPRITE + digitFrame(0);
        this.coinDigitEls.push(d);
        coinGroup.appendChild(d);

        bar.appendChild(coinGroup);

        // — Rat × lives —
        const livesGroup = document.createElement('div');
        livesGroup.style.cssText = 'display:flex;gap:4px;align-items:center;';

        const ratIcon = document.createElement('div');
        ratIcon.style.cssText = SPRITE + statusFrame(0, 0);
        livesGroup.appendChild(ratIcon);

        const timesLives = document.createElement('div');
        timesLives.style.cssText = SPRITE + statusFrame(1, 0);
        livesGroup.appendChild(timesLives);

        const livesDigit = document.createElement('div');
        livesDigit.style.cssText = SPRITE + digitFrame(this.lives);
        this.livesDigitEl = livesDigit;
        livesGroup.appendChild(livesDigit);

        bar.appendChild(livesGroup);
        document.body.appendChild(bar);
        this.updateCoins();
    }

    addCoin() {
        this.coinCount += 1;
        if (this.coinCount >= 100) {
            this.coinCount = 0;
            this.addLife();
        }
        this.updateCoins();
    }

    updateCoins() {
        const digits = String(this.coinCount).padStart(2, '0').split('').map(Number);
        while (this.coinDigitEls.length < digits.length) {
            const d = document.createElement('div');
            this.coinDigitEls.push(d);
            this.coinDigitContainer.appendChild(d);
        }
        digits.forEach((d, i) => {
            this.coinDigitEls[i].style.cssText = SPRITE + digitFrame(d);
        });
    }

    addLife() {
        this.setLives(this.lives + 1);
    }

    setLives(n) {
        this.lives = n;
        this.livesDigitEl.style.cssText = SPRITE + digitFrame(this.lives % 10);
    }

    update() {
        const health = this.player.health;
        if (health === this._lastHealth) return;
        this._lastHealth = health;
        this.heartEls.forEach((h, i) => {
            let state;
            if (health >= i + 1) state = 'full';
            else if (health >= i + 0.5) state = 'half';
            else state = 'empty';
            h.style.cssText = SPRITE + heartStyle(state);
        });
    }
}
